module.exports = __webpack_public_path__ + "img/product-3.f1069255.jpg";